// tslint:disable-next-line:no-var-requires
import {
  Datagrid,
  List,
  Show,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  Toolbar,
  Pagination,
  BooleanField,
  BooleanInput,
} from "react-admin";

const PostPagination = (props) => (
  <Pagination rowsPerPageOptions={[100, 300, 500]} {...props} />
);

const CDPRFilter = (props) => (
  <Filter {...props}>
    <TextInput label="id" source="id" alwaysOn />
    <TextInput label="Prix moyen" source="prix_moyen" alwaysOn />
    <BooleanInput label="Display" source="display" />
  </Filter>
);

export const CDPRList = (props) => (
  <List {...props} filters={<CDPRFilter />} pagination={<PostPagination />}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="prix_moyen" />
      <TextField source="prix_moyen_nbr_meange" />
      <BooleanField source="display" />

      <ShowButton label="" />
      <EditButton label="" />
      <DeleteButton label="" redirect={false} />
    </Datagrid>
  </List>
);

export const CDPRShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="prix_moyen" />
      <TextField source="prix_moyen_nbr_meange" />
      <BooleanField source="display" />
    </SimpleShowLayout>
  </Show>
);

export const CDPREdit = (props) => (
  <Edit {...props}>
    <SimpleForm redirect={false} toolbar={<Toolbar alwaysEnableSaveButton />}>
      <TextInput source="id" />
      <TextInput source="prix_moyen" />
      <TextInput source="prix_moyen_nbr_meange" />
      <BooleanInput source="display" />
    </SimpleForm>
  </Edit>
);
